module.exports = __webpack_public_path__ + "static/media/St_VS_BnH_P.20ee4062.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/St_VS_BnH_P.png
// module id = 92
// module chunks = 0